import React from 'react';
import Title from './layout/Tittle';
import Container from './layout/Container';
import Contents from './layout/Contents';
import Tab from './layout/Tab';
import TabItem from './layout/TabItem';
import {Breadcrumb} from './layout/Breadcrumb';
import {BasicButton, PositiveButton} from './layout/Button';
import {BasicLink, PositiveLink} from './layout/Link';

class MypageLayout extends React.Component {
  static Title = Title;
  static Container = Container;
  static Contents = Contents;
  static Tab = Tab;
  static TabItem = TabItem;
  static Breadcrumb = Breadcrumb;

  render() {
    const {children} = this.props;
    return <div>{children}</div>;
  }
}

export default MypageLayout;
export {
  Title,
  Container,
  Contents,
  Tab,
  TabItem,
  Breadcrumb,
  BasicButton,
  PositiveButton,
  BasicLink,
  PositiveLink,
};
